import { FormBase } from 'core/components';

export default class InsuranceCoverageStatusOverviewEmailEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'to',
                    label: 'To',
                    placeholder: 'To',
                    rules: 'string|required'
                },
                {
                    name: 'cc',
                    label: 'Cc',
                    placeholder: 'Cc',
                    rules: 'string'
                },
                {
                    name: 'bcc',
                    label: 'Bcc',
                    placeholder: 'Bcc',
                    rules: 'string'
                },
                {
                    name: 'replyTo',
                    label: 'Reply To',
                    placeholder: 'Reply To',
                    rules: 'string|required'
                },
                {
                    name: 'subject',
                    label: 'Subject',
                    placeholder: 'Subject',
                    rules: 'string|required'
                },
                {
                    name: 'body',
                    label: 'Body',
                    placeholder: 'Body',
                    rules: 'string'
                },
                {
                    name: 'includePickTicket',
                    type: 'bool',
                    value: false
                },
            ],
        };
    }
}
